/* eslint-disable react/prop-types */ import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useHydration } from '@shared/hooks/useHydration';
import React from 'react';
const GalleryContent = ({ children, requestFilteredLoading, loadingComponent })=>{
    const isHydrated = useHydration();
    return isHydrated && requestFilteredLoading ? loadingComponent : /*#__PURE__*/ _jsx(_Fragment, {
        children: children
    });
};
export default GalleryContent;
